import React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "~/lib/utils"

// TODO(dev): Add these sub-components as needed when converting legacy views to React.
// NOTE: This component has been refactored to use composition but not all legacy cases
// are covered yet. When migrating existing page headers, you may need to add support for:
// - PageHeaderSubtitle (for .page-header__subtitle)
// - PageHeaderTabs (for .page-header__tabs - see /campaigns/reporting)
// - PageHeaderBreadcrumb (for .page-header-breadcrumb)
// - PageHeaderHeading (for .page-header__heading wrapper)
// See app/frontend/stylesheets/_layout.scss for all existing page-header classes.

const pageHeaderVariants = cva("page-header", {
  variants: {
    variant: {
      default: "",
      ghost: "page-header--ghost",
    },
  },
  defaultVariants: {
    variant: "default",
  },
})

interface PageHeaderProps extends React.HTMLAttributes<HTMLElement>, VariantProps<typeof pageHeaderVariants> {}

const PageHeader = React.forwardRef<HTMLElement, PageHeaderProps>(({ className, variant, children, ...props }, ref) => {
  return (
    <header ref={ref} className={cn(pageHeaderVariants({ variant }), className)} {...props}>
      {children}
    </header>
  )
})

PageHeader.displayName = "PageHeader"

interface PageHeaderTitleProps extends React.HTMLAttributes<HTMLHeadingElement> {}

const PageHeaderTitle = React.forwardRef<HTMLHeadingElement, PageHeaderTitleProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <h1 ref={ref} className={cn("page-header__title", className)} {...props}>
        {children}
      </h1>
    )
  },
)

PageHeaderTitle.displayName = "PageHeaderTitle"

interface PageHeaderActionsProps extends React.HTMLAttributes<HTMLDivElement> {}

const PageHeaderActions = React.forwardRef<HTMLDivElement, PageHeaderActionsProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div ref={ref} className={cn("page-header__actions", className)} {...props}>
        {children}
      </div>
    )
  },
)

PageHeaderActions.displayName = "PageHeaderActions"

export { PageHeader, PageHeaderTitle, PageHeaderActions }
